import { FormContainer } from "@/components/form/FormContainer";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { UpdateWrapper } from "@/layouts/UpdateWrapper";
import {
  useResourceParams,
  useOne,
  useUpdate,
  useInvalidate,
} from "@refinedev/core";
import { Button, Space, Spin } from "antd";
import { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNodegroupConfig } from "@/hooks/config/useNodegroupConfig";
import { deriveUIDefaultsFromServerFormat } from "@/components/instance/config/ServerToClientConverter";
import { appendDefaultValuesToColumns } from "@/components/instance/config/ServerToClientConverter";
import { getNodegroupConfig } from "@/components/instance/config/ClientToServerConverter";

export const UpdateNodegroupSize = ({ id, action }) => {
  // console.log(useResourceParams());
  const [initialValue, setInitialValue] = useState({});

  const { data, isLoading, isError } = useOne({
    resource: "nodegroups",
    id,
  });

  useEffect(() => {
    if (isLoading) return;

    if (isError || data?.data?.status === "error") {
      // notification.error({
      //   message: "Error",
      //   description: "Fail to get instance profile",
      // });
      return;
    }
    const { nodegroups } = data;
    const defaultValue = deriveUIDefaultsFromServerFormat({ nodegroups });
    setInitialValue(defaultValue);
  }, [data, isLoading, isError]);

  return isLoading ? (
    <div>Loading...</div>
  ) : isError ? (
    <div>Failed to get nodegroup profile.</div>
  ) : (
    <UpdateNodegroupUI
      id={id}
      action={action}
      initialValue={initialValue}
      enableDruid={data.enableDruid}
    ></UpdateNodegroupUI>
  );
};

export const UpdateNodegroupUI = ({ id, action, initialValue, enableDruid }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const rawValue = {};

  const [submitting, setSubmitting] = useState(false);
  const invalidate = useInvalidate();

  const schema = useNodegroupConfig(enableDruid, "update", initialValue, "", "nodegroups");

  const columns = appendDefaultValuesToColumns([schema], initialValue);

  const { mutate: update } = useUpdate({
    resource: "nodegroups",
    successNotification: (data, values, resource) => {
      setSubmitting(false);
      invalidate({
        resource,
        invalidates: ["list"],
      });
      navigate({
        resource: "nodegroups",
        // key: values.id,
        action: "list",
      });
      return {
        message: t(`nodegroups.actionResult.${action}.success`, {
          id: values?.id,
        }),
        type: "success",
      };
    },
    errorNotification: (data, values, resource) => {
      setSubmitting(false);
      return {
        message: t(`nodegroups.actionResult.${action}.failed`, {
          id: values?.id,
        }),
        type: "error",
      };
    },
  });

  const doCommit = (values) => {
    if (values === undefined) return;
    setSubmitting(true);
    console.log(values);

    const profile = getNodegroupConfig(values);
    update({
      id,
      values: { data: { nodegroups: profile }, action },
      meta: { action },
    });
  };
  if (Object.keys(initialValue).length == 0) return <></>;

  return (
    <Spin spinning={submitting}>
      <UpdateWrapper
        footer={
          <Space>
            <Button
              onClick={() => {
                formRef.current.submit();
                navigate({ resource: "nodegroups", action: "list" });
              }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={() => formRef.current.submit()}>
              Save
            </Button>
          </Space>
        }
      >
        <FormContainer
          formRef={formRef}
          initValue={rawValue}
          schema={columns[0]}
          onFinishCallback={doCommit}
          // grid-template-columns="repeat(2, 1fr)"
        />
      </UpdateWrapper>
    </Spin>
  );
};
